export class VisitInfo {
    VisitID: number;
    VisitDate: Date;
    VisitTime: string;
    CaseID: number;
    Constituent: string;
    Activity: string;
    Insurer: string;
    VisitName: string;
    VisitCity: string;
    VisitStreet: string;
    VisitHouseNumber: string;
    VisitPostalCode: string;
    VisitTelephone: string;
    VisitTelephoneWork: string;
    VisitTelephoneMobile: string;
    TotalPhotos: number;
    TotalDocuments: number;

    public constructor(init?: Partial<VisitInfo>) {
        Object.assign(this, init);
    }
}
